
import { defineComponent, ref } from 'vue'
import { useRoute } from 'vue-router'
import { axios } from '@/plugins/axios'
import { useStore } from '@/store/index'

export default defineComponent({
  props: {
    isCompleted: {
      type: Boolean,
      'default': () => (false),
    },
  },
  setup() {
    const store = useStore()
    const route = useRoute()
    const btnDisabled = ref(false)

    const watchCompletionSwitch = () => {
      btnDisabled.value = true
      axios
        .post(`/video/completion/${route.params.video_id}`)
        .then(response => {
          store.commit('video/setVideoDetails', response.data.payload)
        })
        .finally(() => btnDisabled.value = false)
    }

    return {
      watchCompletionSwitch,
      btnDisabled
    }
  },
})
